import React from 'react'
import styled from 'styled-components'
import { Formatting } from '../../utils/formatting'
import { ListItemProps, ListItem } from '../ListItem'

export interface ListItemWithPercentageProps extends Omit<ListItemProps, 'adornment'> {
  truncatedTextLength?: number | undefined
  percentageWeight: number
}

export const ListItemWithPercentage: React.FC<ListItemWithPercentageProps> = ({
  percentageWeight,
  text,
  truncatedTextLength,
  ...rest
}) => {
  const truncatedText =
    truncatedTextLength && text.length >= truncatedTextLength
      ? `${text.substring(0, truncatedTextLength - 3)}...`
      : text

  return (
    <ListItem
      {...rest}
      text={truncatedText}
      adornment={<Percentage style={{ justifySelf: 'flex-end' }}>{Formatting.percentage(percentageWeight)}</Percentage>}
    />
  )
}

const Percentage = styled.div`
  font-weight: bold;
  font-size: 1.7rem;
  margin-right: 1.5rem;
`
